import { API_ENDPOINT } from "@/constants/appConstants";
import { useLogin } from "@/context/useLoginProps";
import React from "react";

const LoginHeader: React.FC = () => {
  const { hostname, isMobile } = useLogin();

  const loginToRegisterRedirect = () => {
    const params = new URLSearchParams(window.location.search);
    const return_url = params.get("return_url");
    if (return_url) {
      document.location.href = `/seeker/registration?return_url=${return_url}`;
    } else {
      document.location.href = "/seeker/registration";
    }
  };

  return (
    <header className="bg-surface-primary-purple-s90 z-50 w-full border px-3 md:bg-white">
      <div
        className={`mx-auto flex items-center justify-between ${isMobile ? "h-12 w-full" : "h-16 w-[85%!important]"}`}
      >
        <a href="/" aria-label="foundit logo" title="foundit logo">
          <img
            src={API_ENDPOINT(hostname).media.founditLogo}
            alt="Foundit Logo"
            className="h-[24px] w-[97px]"
          />
        </a>
        <nav
          className={`max-md flex items-center font-medium leading-6 text-[#17142A] ${isMobile ? "text-xs" : "text-base"}`}
        >
          <span>New to foundit?&nbsp;</span>
          <span
            className="cursor-pointer font-bold text-violet-800"
            onClick={loginToRegisterRedirect}
          >
            Register
          </span>
          <span>&nbsp;here</span>
        </nav>
      </div>
    </header>
  );
};

export default LoginHeader;
